import { useQuery } from '@tanstack/react-query';
import { AIRequests } from 'src/requests/ai';
import { QueryKey } from 'src/utils/react-query';

export const useConversationsQuery = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [QueryKey.AI_CHATS],
    queryFn: AIRequests.fetchConversations,
    refetchOnWindowFocus: true,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchInterval: false,
  });

  return {
    conversations: data || [],
    isConversationsLoading: isLoading,
    refetchAIList: refetch,
  };
};
